import { Box } from "@outschool/backpack";
import * as FilestackUrls from "@outschool/filestack-urls";
import React from "react";

type ClassImageProps = {
  photoUrl: string | null | undefined;
};

export const ClassImage: React.FunctionComponent<ClassImageProps> = ({
  photoUrl
}) => {
  return (
    <Box
      sx={{
        size: "40px",
        minHeight: "40px",
        minWidth: "40px",
        borderRadius: "8px",
        backgroundSize: "cover",

        backgroundImage: `url("${FilestackUrls.imageUrl(photoUrl, {
          // Double image size for retina displays
          height: 130,
          width: 80,
          fit: "crop"
        })}")`
      }}
    />
  );
};
